import 'rxjs/add/operator/map';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Enum } from '../../utility/enum.enum';
import { userRole_globalAdmin, userRole_regionalAdmin, userRole_siteAdmin } from './../../Common/appConstant';
import { AppMessage } from './../../Common/appMessage';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../dialog-confirm-component/dialog-confirm-component.component';
import { AdmManageExceptionCalenderService } from './adm-manage-exception-calender.service';

@Component({
  selector: 'app-adm-manage-exception-calender',
  templateUrl: './adm-manage-exception-calender.component.html',
  styleUrls: ['./adm-manage-exception-calender.component.css'],
  providers: [AdmManageExceptionCalenderService]
})
export class AdmManageExceptionCalenderComponent implements OnInit {
  @ViewChild(MdSort) sort: MdSort;
  regionFilteredOptions: any;
  locationFilteredOptions: any;
  form: FormGroup;
  showField: boolean;
  addressTitle: string;
  isaddBtnDisable: boolean;
  currentDate: any;
  minDate: any;
  dataSource: TableDataSource | null;
  paginationInfo: any;
  year: any; // save year values
  role: string;
  conflictData: any;
  conflictPaginationInfo: any;
  isFromTimeDisable: boolean = false;
  isToTimeDisable: boolean = false;
  isAddDisable: boolean = true;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  displayedColumns = ['day', 'fromDateTime', 'toDateTime', 'occasion', 'action'];
  constructor(private _sharedService: SharedService, public _utility: Utility, public _appGlobal: AppGlobals, private _calenderService: AdmManageExceptionCalenderService,
    private _appMessage: AppMessage, public _dialog: MdDialog) {
    this.form = new FormGroup({
      regionId: new FormControl(''),
      locationId: new FormControl('', Validators.required),
      fromDateTime: new FormControl(new Date(), Validators.required),
      fromTime: new FormControl('00:00', [Validators.required]), // This value , we will append in fromDateTime when perform Add operation
      isFromAllDay: new FormControl(false), //check box
      toDateTime: new FormControl(new Date(), Validators.required),
      toTime: new FormControl('12:00', Validators.required), // This value , we will append in toDateTime when perform Add operation
      isToAllDay: new FormControl(false),
      occasion: new FormControl('', Validators.required),
      yearControl: new FormControl((new Date).getFullYear())
    });
    this.showField = true;
    this.paginationInfo = { totalRecords: -1 }; // Set initial value of Totalrecords property
    this.role = this._appGlobal.userInfo.getValue().userRole;
    this.checkPermission();
    this.isaddBtnDisable = true;
    this.currentDate = new Date();
    this.minDate = new Date();
    this.year = [];
    this.year.push(this.currentDate.getFullYear());
  }

  ngOnInit() {

    this.dataSource = new TableDataSource(this.dataSubject, null, this.sort);

    // to get data of all regions and bind with AutoComplete
    if (this.role.toUpperCase() == userRole_globalAdmin) {
      if (this._sharedService.regionList) {
        this._utility.setDataInComboField('region', null, this.form.controls.regionId, this);
      } else {
        this._utility.addLoaderCount();
        this._sharedService.getComboFieldsData(Enum.Region, (response) => {
          this._utility.removeLoaderCount();
          this._sharedService.regionList = response.response;
          this._utility.setDataInComboField('region', null, this.form.controls.regionId, this);
        });
      }
    }

    //this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.LocationName, (response) => {
      //this._utility.removeLoaderCount();
      this._sharedService.locationList = response.response;
      // IF role is site admin or regional admin then only load all data on location combos
      // If role is global admin then load locations based on region changes
      if (this.role.toUpperCase() != userRole_globalAdmin) {
        this._utility.setDataInComboField('location', null, this.form.controls.locationId, this);
        // If location has only one record then populate that into field
        if (this._sharedService.locationList.length == 1) {
          this.form.controls.locationId.setValue(this._sharedService.locationList[0]);
        }
      }
    });

    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        if (this.form.dirty && this.form.controls.occasion.value) {
          this.isAddDisable = this._utility.searchDisable(form, ['fromDateTime', 'fromTime', 'isFromAllDay', 'toDateTime', 'toTime', 'isToAllDay', 'occasion', 'yearControl'],false);
          this._utility.setTxnStatus(true);
        }
      });

    this.form.controls.regionId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(value => {
        this.regionChanges(value);
      });

    this.form.controls.locationId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(value => {
        this.locationChanges(value);
      });

    this.form.controls.fromDateTime.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.fromDateChange(value);
      });

    this.form.controls.toDateTime.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.toDateChange(value);
      });

    this.form.controls.isFromAllDay.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.isFromAllDayChange(value);
      });
    this.form.controls.isToAllDay.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.isToAllDayChange(value);
      });

    this.form.controls.fromTime.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe(value => {
        this.validateDate();
      });

    this.form.controls.toTime.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe(value => {
        this.validateDate();
      });

    this.form.controls.yearControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(value => {
        this.onYearChange(value);
      });
  }

  /**
   * Check User Role
   * Load grid columns and search field as per User role
   */
  checkPermission() {
    if (this.role && this.role.toUpperCase() == userRole_globalAdmin) {
      this.showField = true;
      this.form.controls.regionId.setValidators(Validators.required); // IF role is global admin then region field is required
    } else if (this.role && this.role.toUpperCase() == userRole_siteAdmin || this.role && this.role.toUpperCase() == userRole_regionalAdmin) {
      this.showField = false;
    }
  }

  //get data for year dropdown
  getClosureYear() {
    let id = this.form.controls.locationId.value.id;
    if (!id) return;
    //this._utility.addLoaderCount();
    this._calenderService.getYears("?locationId=" + id).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        if (response.response && response.response.results) {
          if (response.response && response.response.results.length > 0) {
            this.year = response.response.results;
            // set first value in year dropdown If current year value does not exists, when we set value, yearField valuechanges event will be called
            if (this.year.indexOf(this.currentDate.getFullYear()) < 0) {
              this.form.controls.yearControl.setValue(this.year[0]);
            } else {
              this.getExcepetionCalenderDetails(); // load calender data of selected location
            }
          } else {
            this.paginationInfo = { totalRecords: 0 }; // If no data in years set Totalrecords property of pagination Info
          }
        }
      }, false)
    }, error => this._utility.onErrorCallback(error));
  }

  /**
   * Get Exception calender records based on selected Location and year
   */
  getExcepetionCalenderDetails() {
    let id = this.form.controls.locationId.value.id;
    if (!id) return;
    let year = this.form.controls.yearControl.value; // get year value from Year dropdown
    let params = "1?pageSize=500&locationId=" + id + "&year=" + year;
    this._utility.addLoaderCount();
    this._calenderService.getData(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        if (response.response.paginationInfo) { this.paginationInfo = response.response.paginationInfo; }// update paginaton info
        this.dataSubject.next(response.response.results);
      });
    }, error => this._utility.onErrorCallback(error))
  }

  //updating location autocomplete when region changes
  regionChanges(value: any): void {
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField('location', response.response.results, this.form.controls.locationId, this);
        });

      });
    } else {
      this.locationFilteredOptions = null;
    }
    this.form.controls.locationId.setValue('');
  }

  /**
   * Set location address to addressTitle variable
   * load grid data after selected location
   * load year values after selection of location
   * @param value - selected value from location dropdown
   */
  locationChanges(value: any): void {
    if (value && value.id) {
      this.addressTitle = value.locationAddress.trim();

      this.getClosureYear();
      this.isaddBtnDisable = false;
      this.form.controls.occasion.markAsTouched(); // WHEN Select a location, display Reason as required field message
    } else {
      this.form.controls.occasion.markAsUntouched();
      this.isaddBtnDisable = true;
      this.addressTitle = '';
      this.paginationInfo = { totalRecords: -1 };
      this.year = [];
      this.year.push(this.currentDate.getFullYear());
      this.form.controls.yearControl.setValue((new Date()).getFullYear()); // reset to current year
      this.hideConflictGrid();
    }
  }

  /**
   * Check From Date / Time with TO Date / Time and implement validations
   * Check If from date is less than today date
   * Check Validations if All day is checked or not checked
   */
  validateDate() {
    let fromDate = this.form.controls.fromDateTime;
    let toDate = this.form.controls.toDateTime;
    let startDate = fromDate.value, endDate = toDate.value;
    let todayDate = new Date();
    if (startDate && endDate) {
      // If all day is unchecked then add time with date and then check time date validation
      let fromTime = this.form.controls.fromTime.value;
      let toTime = this.form.controls.toTime.value;
      if (!(this.form.controls.isFromAllDay.value == true || this.form.controls.isToAllDay.value == true)) {
        startDate = new Date(fromDate.value.toLocaleDateString() + " " + fromTime);
        endDate = new Date(toDate.value.toLocaleDateString() + " " + toTime);
      }
      else {
        startDate = this._utility.convertToDateStr(startDate, 'd');
        endDate = this._utility.convertToDateStr(endDate, 'd');
      }
      if (startDate > endDate) {
        toDate.setErrors({ invalid: true }); // set custom error to make this field invalid
      } else {
        toDate.setErrors(null);
      }
    }
  }

  /**
   * Load grid based on year selection
   * @param year - selected year value
   */
  onYearChange(year) {
    this.getExcepetionCalenderDetails();
  }

  fromDateChange(value: any) {
    value ? this.minDate = new Date(value) //  Set Min date in ToDate field
      : this.minDate = new Date();
    this.validateDate();
  }
  toDateChange(value: any) {
    this.validateDate();
  }

  //from date all day Checkbox value changes
  isFromAllDayChange(value: boolean): void {
    this.isFromTimeDisable = value;
    this.validateDate();
  }

  //to date all day Checkbox value changes
  isToAllDayChange(value: boolean): void {
    this.isToTimeDisable = value;
    this.validateDate();
  }

  onAdd(): void {
    if (this.form.invalid) return;

    let formData = this.form.getRawValue();
    formData = this._utility.manageFormDataforSave(formData);
    formData.fromDateTime = this._utility.convertToDateStr(formData.fromDateTime, 'd'); // here 'd' means we have to get Date part only
    formData.toDateTime = this._utility.convertToDateStr(formData.toDateTime, 'd');

    // If all day is selected for from date and not for to date but to date is same as from date,then to all day is set to true
    if (formData.isFromAllDay && formData.fromTime && (formData.fromDateTime == formData.toDateTime)) {
      formData.isToAllDay = true;
    }
    // If all day not selected then only add time with date
    if (!formData.isFromAllDay && formData.fromTime) {
      formData.fromDateTime = formData.fromDateTime + ' ' + formData.fromTime + ":00"; // added seconds as 00 because it needs in API
    }
    if (!formData.isToAllDay && formData.toTime) {
      formData.toDateTime = formData.toDateTime + ' ' + formData.toTime + ":00";
    }
    // create param which we need for API
    let param = {
      fromDateTime: formData.fromDateTime,
      toDateTime: formData.toDateTime,
      locationId: formData.locationId,
      occasion: formData.occasion,
      isFromAllDay: formData.isFromAllDay,
      isToAllDay: formData.isToAllDay
    }
    this.hideConflictGrid(); // Hide conflict Grid when You try to add any new closure
    //display confimation box
    let confimrMsg = this._appMessage.getItem['UMsg00058'];// "Select Yes to block the calendar on the specified dates and times."
    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],//'Are you sure?',
      msg: confimrMsg,
      isConfirmBox: true,
      confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
      cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
    };
    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      //when selected ok from the confimation box
      if (result == "1") {
        this._calenderService.addData(param).subscribe(response => {
          if (response.responseCode && response.responseCode.toUpperCase() == "E1153") {  // when conflict occur,response code is E1153
            this._utility.removeLoaderCount();
            if (response.response && response.response.results && response.response.paginationInfo) {
              this.resetForm();
              // send to child component i.e conflict as @INPUT
              this.conflictData.message = this._appMessage.getItem["UMsg00059"];
              this.conflictData.response = response.response;
              this.conflictPaginationInfo = response.response.paginationInfo; // update paginaton info
            }
            return;
          } else {
            this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00030'], () => {
              this._utility.clearTxnStatus();
              this.resetForm();
              this.getExcepetionCalenderDetails(); // load all records after add new one
              this.getClosureYear();
            });
          }
        }, error => this._utility.onErrorCallback(error))
      }
    })
  }

  /**
   * If location changes, then hide conflict grid.
   */
  hideConflictGrid() {
    this.conflictData = {};
    this.conflictPaginationInfo = { totalRecords: 0 };
  }

  // After add new closure , reset form values
  resetForm(): void {
    let controls = this.form.controls;
    controls.occasion.reset();
    controls.isFromAllDay.setValue(false);
    controls.isToAllDay.setValue(false);
    controls.toDateTime.setValue(new Date());
    controls.fromDateTime.setValue(new Date());
    controls.fromTime.setValue('00:00');
    controls.toTime.setValue('12:00');
  }

  /**
   * Call this function to remove particular records
   * @param id - selected row Id
   */
  onRemove(id: number): void {
    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],
      msg: this._appMessage.getItem['UMsg00051'],
      isConfirmBox: true,
      confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
      cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
    };

    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      if (result == "1") {
        this._utility.addLoaderCount();
        let param = { id: id }; // pass location Id
        this._calenderService.removeData(param).subscribe(response => {
          this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00052'], () => {
            this.getExcepetionCalenderDetails();
          });
        }, error => this._utility.onErrorCallback(error));
      }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-exception-calender/adm-manage-exception-calender.component.ts